import { useEffect } from 'react';
import { useThemeStore, resolveIsDark } from '../store/theme';

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const mode = useThemeStore((s) => s.mode);

  useEffect(() => {
    const apply = () => {
      const dark = resolveIsDark(mode);
      document.documentElement.classList.toggle('dark', dark);
    };

    apply();

    if (mode === 'system') {
      const mq = window.matchMedia('(prefers-color-scheme: dark)');
      mq.addEventListener('change', apply);
      return () => mq.removeEventListener('change', apply);
    }
  }, [mode]);

  return <>{children}</>;
}
